// extracted by mini-css-extract-plugin
export var orderDetails = "_mm-2";
export var orderImage = "_mm-1";
export var orderMeta = "_mm-3";
export var orderSummary = "_mm-0";
export var rightArrow = "_mm-4";